import { gql } from "@apollo/client"

// Separate from MEMBER_APPLY_PATH_QUERY and PTM_MEMBERSHIP_APPLICATIONS_QUERY: a
// Coach Tools without these fields rejects the whole document, which would
// hide the apply action and every Associate/Affiliate status.
export const RECIPROCITY_APPLICATIONS_QUERY = gql`
  query ReciprocityApplications {
    membershipApplications(applicationType: member) {
      id
      applicationType
      status
      reciprocityType
      electionDate
      electedAt
      updatedAt
    }
  }
`
